import { createContext, useState, useEffect } from "react";

export const ThemeContext = createContext();

const themes = ["light", "dark"]; //, "blue", "yellow", "pink"

export const ThemeProvider = ({ children }) => {
    const storedTheme = localStorage.getItem("theme") || "light"; 
    const [theme, setTheme] = useState(storedTheme);

    useEffect(()=> {
        document.documentElement.setAttribute("data-theme", theme);
        localStorage.setItem("theme", theme)
    }, [theme]);

    const changeTheme = (newTheme) => {
        if (themes.includes(newTheme)) {
            setTheme(newTheme);
        }
    };

    return (
        <ThemeContext.Provider value={{ theme, changeTheme, themes}}>
            {children}
        </ThemeContext.Provider>
    )

}